// extracted by mini-css-extract-plugin
export default {"minorButton":"MinorButton_minorButton__eR-7N"};